module.exports = __webpack_public_path__ + "img/3.438476fa.jpg";